export const typesKeyNames = {
    // 1: 'passbook',
    //3: 'old_roll',
    5: 'counterfoil',
    6: 'roll',
    7: 'stickers',
    8: 'evolis',
    //9: 'counterfoil_us',
    11: 'pdf',
    // Merged Badge types 12 and 11 in the type 11
    // 13: 'generic_zpl',
    14: 'app_v1'
};

export const groupTypes = {
    // passbook: [1],
    pdf: [11],
    thermal: [5, 6, 7, 8],
    app: [14]
};

export const typesWithoutPreview = [14];

export const typesSkipValidation = [14];

export function getAvailableTypes(templates, t) {
    return Object.entries(groupTypes)
        .filter(([group, types]) => types.some(type => templates.some(template => template.type === type)))
        .map(([group, types]) => {
            return {
                value: group,
                text: t(`ticket.ticket_design.group_type.${group}`),
                children: types
                    ?.filter(type => templates.some(template => template.type === type))
                    ?.map(type => {
                        const [key, value] = Object.entries(typesKeyNames).find(([key, value]) => Number(key) === type);
                        return {
                            key: key,
                            name: key,
                            value: Number(key),
                            text: t(`ticket.ticket_design.type.${value}`),
                            parent: group
                        };
                    })
            };
        });
}
